import { IRangeXpath, IRecreationData } from './highlightServerTypes';
export enum NoteState {
  LOCAL, // a local note is a note that does not exist on the server yet. This means that data might be missing
  REMOTE, // a remote note should contain all data known
  RESTORED // restored notes are not 1-1 with reality, only when we edit and save them?
}

export interface NoteHighlightRecreation extends IRecreationData {}

export interface NoteHighlightRange extends IRangeXpath {}

export interface NoteHighlight {
  // No id is ok! The Vuex implementation will handle generating an id for you.
  // An id is expected on items you get from the server, though.
  id: string | null;

  // Timestamp for creation - you don't have to provide this.
  createdTimestamp: number;

  // Used internally for the dynamodb in the server.
  // You don't have to provide this, as it should be handled by the highlightService.
  timestampSortKey: number | null;

  // Color class, e.g. "hl-yellow"
  hlcolor: string;

  // Selected text
  selectedText: string;

  // Range objects - assume there is only one kind
  ranges: NoteHighlightRange[];

  // Data for recreation
  recreationData: NoteHighlightRecreation;

  // Comment text - provided by user, might be nothing!
  userComment: string | null;

  // Page id for what page highlight belongs to
  pid: string;
}
